module.exports = __webpack_public_path__ + "static/media/unlock-tool-white.8147db94.svg";